




















































































import {Component, Emit, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Post from '@/models/Post'
import Tag from '@/models/Tag'
import MediaSelector from '@/components/admin/MediaSelector.vue'
import {Medium} from '@/models/Medium'
import TinyMce from '@/components/admin/TinyMce.vue'

type MediaSelectMode = 'thumbnail' | 'ogpImage' | 'twitterImage' | ''

@Component({
  components: {
    TinyMce,
    MediaSelector
  }
})
export default class PostForm extends VueBase {
  @Prop(Object) readonly value!: Post
  @Prop({ type: Array, default: ()=> [] }) readonly tags: Array<Tag>
  showedMediaSelector = false
  mediaSelectMode: MediaSelectMode = ''

  @Emit('input')
  input(value: Post): Post {
    return value
  }

  @Emit()
  onSave(): Post {
    return this.value
  }

  @Emit()
  onPreview(): Post {
    return this.value
  }

  get internalValue(): Post {
    return this.value
  }

  set internalValue(val: Post) {
    this.input(val)
  }

  get selectedTagIds(): Array<number> {
    return this.value.tags.map(t => t.id)
  }

  set selectedTagIds(val: Array<number>) {
    this.value.tags = val.map(v => new Tag({ id: v, position: 0 }))
    this.input(this.value)
  }

  options = {
    language_url: require('./ja.js')
  }
  toolbar1 = 'fontselect | fontsizeselect | formatselect | bold | italic | underline | strikethrough | forecolor | backcolor | removeformat | link | unlink'
  toolbar2 = 'bullist | numlist | hr | media | pastetext | searchreplace | nonbreaking | alignleft | aligncenter | alignright | undo | redo'
  items = [{text: '公開中', value: 'publish'}, {text: '下書き', value: 'draft'}, {text: '非公開', value: 'private'}]

  async mounted(): Promise<void> {
    this.selectedTagIds = this.value.tags.map(t => t.id)
  }

  showMediaSelector(mode: MediaSelectMode): void {
    this.mediaSelectMode = mode
    this.showedMediaSelector = true
  }

  onSelectMedium(medium: Medium): void {
    switch (this.mediaSelectMode) {
      case 'thumbnail':
        this.value.thumbnail = medium
        break
      case 'ogpImage':
        this.value.seo_ogp_image_url = medium.url
        break
      case 'twitterImage':
        this.value.seo_ogp_twitter_image_url = medium.url
        break
    }
    this.showedMediaSelector = false
  }

  clearThumbnail(): void {
    this.value.thumbnail = undefined
  }
}
